/** Sales / demo inbox for waitlist PRD (mailto targets). */
export const TEAM_CONTACT_EMAIL = "team@paribus.dev";
